import { NgModule } from '@angular/core';
import {AppMaterialModule} from "../../appMaterial/app-material.module";
import {FtpDuplicateDirective} from "./ftpDuplicate.directive";

@NgModule({
  imports: [AppMaterialModule],
  exports: [FtpDuplicateDirective],
  declarations: [FtpDuplicateDirective],
  providers: []
})
export class FtpDuplicateModule {}
